<div class="auth-container">
  <picture class="floating-logo" routerLink="/">
    <source srcset="/assets/zeva-logo-dark-blue.svg" media="(prefers-color-scheme: light)" />
    <source srcset="/assets/zeva-logo-white.svg" media="(prefers-color-scheme: dark)" />
    <img src="/assets/zeva-logo-white.svg" style="height: 100%" fetchpriority="high" />
  </picture>
  <!-- <img src="/assets/zeva-logo-no-icon.png" class="floating-logo" routerLink="/" /> -->

  <div class="document-page-content-wrapper content-wrapper">
    <p class="mat-headline-2">{{ documentName | transloco }}</p>

    <div class="content">
      @if (documentHTML) {
        <div [innerHTML]="documentHTML"></div>
      }
      <!-- <iframe [src]="documentURL" *ngIf="documentURL"></iframe> -->
    </div>

    <core-footer />
  </div>
</div>
